// extracted by mini-css-extract-plugin
module.exports = {"recommend":"AskQuestion_recommend_37Q-n","recommendLabel":"AskQuestion_recommendLabel_1ka9O","box":"AskQuestion_box_19LTE","action":"AskQuestion_action_3YjmY"};